// Skyward PM C3 — version and release notes.
// Bump package.json and add a line here with every version.
export const APP_NAME = 'Skyward PM C3';
export const APP_VERSION = '0.2.1';

export const RELEASE_NOTES: { version: string; date: string; notes: string }[] = [
  {
    version: '0.2.1',
    date: '2026-11-04',
    notes:
      'Registers open on all items, latest first, with a sort choice: latest, oldest, number, topic A–Z / Z–A, status, respond-by, amount. PDFs and photos open in an in-page viewer (step through the item\'s files with ← →, download or open in a new tab); other file types download as before.',
  },
  {
    version: '0.2.0',
    date: '2026-11-04',
    notes:
      'Registers: RFIs & site instructions, notices (NOPD/GC/DT/EOT), variations, claims and NDAs — lists with filters, overdue respond-by dates, item pages. Comments on every item: threads with replies, @mentions, attachments, edit/delete your own, SWI-only or shared. Files with versions: upload a new version, older ones stay downloadable. Search across registers. Admin → Import from Smartsheet: trial run, import of rows, comments, every attachment version and cell images, check report, undo per import.',
  },
  {
    version: '0.1.2',
    date: '2026-11-03',
    notes:
      'Email through Resend from mail.skywardindustries.com: Supabase hands every sign-in email (invite, code, password reset, security notices) to PM C3, which sends it branded. Wording lives in the code — no templates to paste in Supabase. Admin → Users: "Send me a test email".',
  },
  {
    version: '0.1.1',
    date: '2026-11-03',
    notes:
      'Live: lists update by themselves when anyone changes something (undo included). Who is online, on which page, and who has a record open. Saves made on an out-of-date copy are stopped. Sign-in, invites and password resets use 6-digit email codes (link scanners can no longer use up the email).',
  },
  {
    version: '0.1.0',
    date: '2026-11-03',
    notes:
      'Foundation: sign-in and invites, client/site switcher, buildings, organisations & contacts, site roles, contracts, file upload/download, roles & permissions, audit log with undo.',
  },
  { version: '0.0.1', date: '2026-11-03', notes: 'Starter: app frame, construction theme, holding page, Netlify config.' },
];
